import { renderIsomorphicComponent, renderComponent } from "@quintype/framework/client/start";

import { pickComponent } from "../isomorphic/pick-component";
import LoadingIndicatorComponent from "../isomorphic/components/atoms/loading-indicator";
import BreakingNewsSliderView from "../isomorphic/components/BreakingNewsSlider";

import TopAd from "../isomorphic/components/molecules/TopAd";
import Footer from "../isomorphic/components/layouts/footer/render-footer-component";
import Header from "../isomorphic/components/layouts/header/UniformHeader";
import InterstitialAd from "../isomorphic/components/molecules/InterstitialAd";
import GdprPolicy from "../isomorphic/components/molecules/GdprPolicy";
import AnchorAd from "../isomorphic/components/molecules/AnchorAd";

function getGlobalUtilities(store) {
  const device = (window.innerWidth < 876 ? "mobile" : "desktop") || "mobile";
  global.device = device;
  const dpr = store.getState()?.qt?.config?.["publisher-attributes"]?.["gumlet-dpr"]?.[device];
  let imgParams = { auto: ["format", "compress"], fmt: "webp" };
  if (dpr) {
    imgParams = { auto: ["format", "compress"], fmt: "webp", dpr };
  }
  global.imgParams = imgParams;
}

export function preRenderApplication(store) {
  getGlobalUtilities(store);

  const hydrate = { hydrate: !global.qtLoadedFromShell };
  renderComponent(Header, "header", store, hydrate);
  renderComponent(Footer, "footer", store);
  renderComponent(LoadingIndicatorComponent, "loading-indicator", store);
}

export function renderApplication(store) {
  const hydrate = { hydrate: !global.qtLoadedFromShell };

  renderComponent(TopAd, "top-ad", store, hydrate);
  renderComponent(InterstitialAd, "interstitial-ad", store, hydrate);

  const breakingNewsbaseProps = {
    ...hydrate,
    updateInterval: 120 * 1000,
  };
  renderComponent(BreakingNewsSliderView, "breaking-news-container", store, breakingNewsbaseProps);
  renderComponent(AnchorAd, "anchor-ad", store, hydrate);

  renderComponent(GdprPolicy, "gdpr-policy", store, hydrate);
  renderIsomorphicComponent("container", store, pickComponent, hydrate);
}
